<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">账套管理</span></div>
		<div class="margin-top margin-left margin-right">
			<div class="flex-row" style="display: flex;">
				<input type="text" v-model="companyName" placeholder="输入单位名称搜索" style="width: 240px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<Button :color="expiring ? 'red' : 'default'" style="margin-left: 8px;" @click="toggleExpiring">
					{{ expiring ? '取消到期筛选' : '即将到期' }}
				</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="companyName" title="单位名称"/>
				<TableItem prop="userCount" title="用户数" :width="90" align="center"/>
				<TableItem title="启用年月" :width="120">
					<template slot-scope="{data}">
						{{ dateFormat(data.enableDate) }}
					</template>
				</TableItem>
				<TableItem title="当前账期" :width="120">
					<template slot-scope="{data}">
						{{ monthFormat(data.currentAccountDate) }}
					</template>
				</TableItem>
				<TableItem title="创建时间" :width="150">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.createDate) }}
					</template>
				</TableItem>
				<TableItem title="状态" :width="100" align="center">
					<template slot-scope="{data}">
						{{ data.status === 0 ? '已禁用' : '启用中' }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="170" align="center">
					<div class="actions" slot-scope="{data}">
						<span v-if="data.status === 0" @click="changeStatus(data, 1)">启用</span>
						<span v-else @click="changeStatus(data, 0)">禁用</span>
						<span @click="openVouchers(data)">凭证</span>
						<span @click="openRecords(data)">续费记录</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showVouchers" hasCloseIcon hasDivider>
			<div slot="header">{{ voucherCompany }} - 凭证列表（只读）</div>
			<div style="max-height: 420px; overflow-y: auto;">
				<Table :datas="voucherList" :loading="voucherLoading">
					<TableItem title="凭证字号" :width="110">
						<template slot-scope="{data}">
							{{ (data.word || '') + '-' + (data.code == null ? '' : data.code) }}
						</template>
					</TableItem>
					<TableItem title="凭证日期" :width="110">
						<template slot-scope="{data}">
							{{ data.voucherDate ? moment(data.voucherDate).format('YYYY-MM-DD') : '' }}
						</template>
					</TableItem>
					<TableItem prop="remark" title="摘要"/>
					<TableItem prop="debitAmount" title="借方金额" :width="110" align="right"/>
					<TableItem prop="creditAmount" title="贷方金额" :width="110" align="right"/>
					<TableItem prop="auditMemberName" title="审核人" :width="90" align="center"/>
				</Table>
			</div>
			<Pagination style="margin-top: 10px;" v-model="voucherPagination" layout="total,pager"
						@change="loadVouchers" small align="right"/>
			<div slot="footer">
				<Button @click="showVouchers=false">关闭</Button>
			</div>
		</Modal>
		<Modal v-model="showRecords" hasCloseIcon hasDivider>
			<div slot="header">{{ voucherCompany }} - 续费流水</div>
			<div style="max-height: 420px; overflow-y: auto;">
				<Table :datas="recordList" :loading="recordLoading">
					<TableItem prop="id" title="ID" :width="70"/>
					<TableItem prop="days" title="续费天数" :width="90" align="center"/>
					<TableItem title="续费前到期" :width="150">
						<template slot-scope="{data}">
							{{ data.oldExpireDate ? moment(data.oldExpireDate).format('YYYY-MM-DD HH:mm') : '未设置' }}
						</template>
					</TableItem>
					<TableItem title="续费后到期" :width="150">
						<template slot-scope="{data}">
							{{ data.newExpireDate ? moment(data.newExpireDate).format('YYYY-MM-DD HH:mm') : '' }}
						</template>
					</TableItem>
					<TableItem title="续费时间" :width="150">
						<template slot-scope="{data}">
							{{ data.createDate ? moment(data.createDate).format('YYYY-MM-DD HH:mm') : '' }}
						</template>
					</TableItem>
				</Table>
			</div>
			<Pagination style="margin-top: 10px;" v-model="recordPagination" layout="total,pager"
						@change="loadRecords" small align="right"/>
			<div slot="footer">
				<Button color="primary" @click="openExtend">赠送时长</Button>
				<Button @click="showRecords=false">关闭</Button>
			</div>
		</Modal>
		<Modal v-model="showExtend" hasCloseIcon hasDivider :width="420">
			<div slot="header">赠送时长 - {{ voucherCompany }}</div>
			<Form ref="extendForm" :labelWidth="100" :model="extendForm">
				<FormItem label="赠送天数" prop="days">
					<input type="number" v-model="extendForm.days" placeholder="1~3650 天"/>
				</FormItem>
				<FormItem label="备注" prop="remark">
					<input type="text" v-model="extendForm.remark" placeholder="选填，如：客服补偿"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button color="primary" :loading="extending" @click="doExtend">确认赠送</Button>
				<Button @click="showExtend=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminAccountSets",
		data() {
			return {
				loading: false,
			companyName: '',
			expiring: false,
			dataList: [],
				showVouchers: false,
				voucherLoading: false,
				voucherCompany: '',
				voucherList: [],
				voucherAsid: null,
				showRecords: false,
				recordLoading: false,
				recordList: [],
				recordPagination: {
					page: 1,
					size: 10,
					total: 0
				},
				showExtend: false,
				extending: false,
				extendForm: {days: 30, remark: ''},
				voucherPagination: {
					page: 1,
					size: 10,
					total: 0
				},
				pagination: {
					page: 1,
					size: 20,
					total: 0
				}
			}
		},
		methods: {
			moment,
			openVouchers(data) {
				this.voucherAsid = data.id;
				this.voucherCompany = data.companyName;
				this.voucherPagination.page = 1;
				this.showVouchers = true;
				this.loadVouchers();
			},
			openRecords(data) {
				this.voucherAsid = data.id;
				this.voucherCompany = data.companyName;
				this.recordPagination.page = 1;
				this.showRecords = true;
				this.loadRecords();
			},
			loadRecords() {
				this.recordLoading = true;
				this.$api.admin.accountSetRenewalRecords({
					accountSetsId: this.voucherAsid,
					page: this.recordPagination.page,
					size: this.recordPagination.size
				}).then(({data}) => {
					this.recordList = data.records || [];
					this.recordPagination.total = Number(data.total || 0);
				}).finally(() => this.recordLoading = false);
			},
			openExtend() {
				this.extendForm = {days: 30, remark: ''};
				this.showExtend = true;
			},
			doExtend() {
				let days = parseInt(this.extendForm.days);
				if (!days || days < 1 || days > 3650) {
					this.$Message.error('赠送天数需在 1~3650 之间');
					return;
				}
				this.extending = true;
				this.$api.admin.extendAccountSets({
					id: this.voucherAsid,
					days: days,
					remark: this.extendForm.remark
				}).then(({msg}) => {
					this.$Message.success(msg || '赠送成功');
					this.showExtend = false;
					this.loadRecords();
					this.loadList();
				}).finally(() => this.extending = false);
			},
			loadVouchers() {
				this.voucherLoading = true;
				this.$api.admin.accountSetVouchers({
					accountSetsId: this.voucherAsid,
					page: this.voucherPagination.page,
					size: this.voucherPagination.size
				}).then(({data}) => {
					this.voucherList = data.records || [];
					this.voucherPagination.total = Number(data.total || 0);
				}).finally(() => this.voucherLoading = false);
			},
			loadList() {
				this.loading = true;
				this.$api.admin.accountSets({
					page: this.pagination.page,
					size: this.pagination.size,
					companyName: this.companyName || undefined,
					expiring: this.expiring || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			toggleExpiring() {
				this.expiring = !this.expiring;
				this.pagination.page = 1;
				this.loadList();
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			changeStatus(data, status) {
				let tip = status === 0
					? `禁用后该账套所有用户将无法登录使用，确认禁用【${data.companyName}】?`
					: `确认启用【${data.companyName}】?`;
				this.$Confirm(tip).then(() => {
					this.loading = true;
					this.$api.admin.updateStatus({id: data.id, status}).then(() => {
						this.$Message('操作成功~');
						this.loadList();
					}).catch(() => {
					}).finally(() => this.loading = false);
				})
			},
			dateFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD') : '';
			},
			monthFormat(date) {
				return date ? moment(date).format('YYYY-MM') : '';
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
